import type { ActionTemplateParameterResource, ControlType } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { BaseParameterSelector } from "~/components/ParameterSelector/BaseParameterSelector";
interface StepTemplatesParameterSelectorProps {
    selectedParameter: string | null | undefined;
    onParameterChange(value: string | null): void;
    controlType: ControlType;
    allowClear: boolean;
    error?: string | undefined;
    label?: string;
    parameters: ActionTemplateParameterResource[];
}
export function StepTemplatesParameterSelector({ allowClear, controlType, error, label, onParameterChange, selectedParameter, parameters }: StepTemplatesParameterSelectorProps) {
    return <BaseParameterSelector selectedParameter={selectedParameter} onParameterChange={onParameterChange} controlType={controlType} allowClear={allowClear} error={error} label={label} parameters={parameters} bindValue={false}/>;
}
